import { Dispatch } from "redux";
import { setLoading, setLoadingModal } from "./global";
import { showMessage } from "utilities/helper";
import MemberService from "service/Member";
import { getAllCatalogGifts } from "./cataloggift";
import { getCatalogById } from "./catalog";

export const getAllMembers =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3,
    filterTier: string = "",
    filterPortal: string = "",
    filterBlacklist: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_MEMBER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_MEMBER",
      searchValue: search,
    });

    try {
      const data = await MemberService.getAllMembers(
        page,
        search,
        limit,
        filterTenant,
        filterTier,
        filterPortal,
        filterBlacklist
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_MEMBER", value: data.users });

      dispatch({
        type: "SET_MEMBER_PAGE",
        totalPage: !!data.users.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.users.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_MEMBER_FILTER_PAGE",
        filterTenantPage: filterTenant,
        filterTierPage: filterTier,
        filterPortalPage: filterPortal,
        filterBlacklistPage: filterBlacklist,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const getAllMembersModal =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
    filterTenant: number = 3,
    filterTier: string = "",
    filterPortal: string = "",
    filterBlacklist: string = ""
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoadingModal(true));
    dispatch({
      type: "SET_MEMBER_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_MEMBER",
      searchValue: search,
    });

    try {
      const data = await MemberService.getAllMembers(
        page,
        search,
        limit,
        filterTenant,
        filterTier,
        filterPortal,
        filterBlacklist
      );

      dispatch(setLoadingModal(false));
      dispatch({ type: "SET_MEMBER", value: data.users });

      dispatch({
        type: "SET_MEMBER_PAGE",
        totalPage: !!data.users.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.users.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_MEMBER_FILTER_PAGE",
        filterTenantPage: filterTenant,
        filterTierPage: filterTier,
        filterPortalPage: filterPortal,
        filterBlacklistPage: filterBlacklist,
      });
    } catch (err: any) {
      dispatch(setLoadingModal(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

export const storeVerifyKTP =
  (
    catalogId: string | undefined,
    userId: string,
    verifiedKTP: boolean,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: "SET_FORM_VERIFY_KTP_LOADING", value: true });

    try {
      const data = await MemberService.storeVerifyKTP(userId, verifiedKTP);
      const { currentPage, searchValue, limitPage } =
        getState().catalogGiftReducer;

      dispatch({ type: "SET_FORM_VERIFY_KTP_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });
      dispatch({ type: "SET_MODAL_VERIFY_KTP", value: false });

      dispatch(
        getAllCatalogGifts(
          catalogId,
          currentPage,
          searchValue,
          limitPage
        ) as any
      );
      dispatch(getCatalogById(catalogId) as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_VERIFY_KTP_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const storeRaffleBlacklist =
  (userId: string) => async (dispatch: Dispatch, getState: any) => {
    try {
      const data = await MemberService.storeRaffleBlacklist(userId);
      const { currentPage, searchValue, limitPage, filterTenantPage, filterTierPage, filterPortalPage, filterBlacklistPage } =
        getState().memberReducer;

      dispatch(
        getAllMembers(
          currentPage,
          searchValue,
          limitPage,
          filterTenantPage,
          filterTierPage,
          filterPortalPage,
          filterBlacklistPage
        ) as any
      );

      showMessage(data?.message || "Blacklist updated", "success");
    } catch (err: any) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
      throw err;
    }
  };
